import React from 'react';
import { useUnitPlaybackManager } from 'state/unitPlaybackManager';

export interface PlaybackAwareCtaProps {
  children?: React.ReactNode;
  interactionProps?: string[];
}

const PlaybackAwareCta: React.FC<PlaybackAwareCtaProps> = ({
  children,
  interactionProps = ['onClick'],
}) => {
  // NB: useUnitPlaybackManager is used to pause instead of usePlayback because
  // useUnitPlaybackManager is capable of pausing any player, whereas usePlayback
  // is only capable of pausing the nearest player up the react tree.  Generally,
  // UnitPlaybackManagerProvider wraps all players and is used to manage playback
  // for all players.
  const { pause } = useUnitPlaybackManager();

  const child = React.Children.only(children);

  return (
    <>
      {React.isValidElement(child) &&
        React.cloneElement(
          child,
          interactionProps.reduce(
            (acc, val) => {
              // we can't really know what type arguments the callback function takes
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              acc[val] = (...args: any[]) => {
                pause();
                child.props[val]?.(...args);
              };
              return acc;
            },
            {} as { [k: string]: unknown },
          ),
        )}
    </>
  );
};

export default PlaybackAwareCta;
